import { tv } from 'tailwind-variants'

import { body2, caption } from '@ui-kit/core/typography'

export const tag = tv({
  slots: {
    container: 'flex flex-row rounded-full px-2 py-0.5',
    text: caption({ bold: true, className: 'text-ui-dark' }),
  },
  variants: {
    interactive: {
      true: {
        container: 'px-4 py-2',
        text: body2({ bold: true, className: 'mr-2' }),
      },
    },
    type: {
      successPrimary: {
        container: 'bg-ui-green',
        text: 'text-ui-light',
      },
      successSecondary: {
        container: 'border-ui-green bg-ui-green-light',
      },
      promo: {
        container: 'bg-brand-lime',
      },
      infoPrimary: {
        container: 'bg-ui-grey-500',
      },
      infoSecondary: {
        container: 'border-ui-grey-500 bg-ui-grey-50',
      },
      inverted: {
        container: 'bg-ui-dark',
        text: 'text-ui-light',
      },
    },
  },
  compoundVariants: [
    {
      interactive: false,
      type: ['successSecondary', 'infoSecondary'],
      className: { container: 'py-0' },
    },
    {
      type: ['successSecondary', 'infoSecondary'],
      className: { container: 'border border-solid' },
    },
  ],
  defaultVariants: {
    interactive: false,
    type: 'successPrimary',
  },
})
